const API_BASE_URL = 'https://pwa-backend.fenrir-tech.fr'; // Les requêtes seront redirigées vers le backend via vercel.json

// Fonction pour s'inscrire
export async function signup(userData) {
  const response = await fetch(`${API_BASE_URL}/users/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

// Fonction pour se connecter
export async function login(credentials) {
    const response = await fetch(`${API_BASE_URL}/users/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });
  
    if (!response.ok) {
      throw new Error(await response.text());
    }
  
    const data = await response.json();
    localStorage.setItem('token', data.token); // Store the token in localStorage
    return data;
}

/// Fonction pour récupérer les informations de l'utilisateur connecté
export async function getUser() {
    const token = localStorage.getItem('token'); // Retrieve the token from localStorage
    if (!token) {
      throw new Error('No token found. Please log in.');
    }
  
    // Decode the token to extract the user ID
    const decodedToken = JSON.parse(atob(token.split('.')[1])); // Decode the payload of the JWT
    const userId = decodedToken.id;
  
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` }, // Pass the token in the Authorization header
    });
  
    if (!response.ok) {
      throw new Error(await response.text());
    }
  
    return response.json();
}

// Fonction pour se déconnecter (si nécessaire)
export function logout() {
  localStorage.removeItem('token');

  // Redirigez l'utilisateur vers la page de connexion
  window.location.href = '/';
}

// Fonction pour récupérer les recettes les plus populaires
export async function getTopRecipes() {
    const response = await fetch(`${API_BASE_URL}/recipts/top`);
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  }
  
  // Fonction pour récupérer les recettes les plus récentes
  export async function getLatestRecipes() {
    const response = await fetch(`${API_BASE_URL}/recipts/latest`);
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
}

// Fonction pour créer une recette
export async function createRecipe(recipeData) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No token found. Please log in.');
  }

  const response = await fetch(`${API_BASE_URL}/recipts`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: recipeData, // Envoyer directement le FormData
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

// Fonction pour mettre à jour une recette
export const updateRecipe = async (id, formData) => {
  const response = await fetch(`${API_BASE_URL}/recipts/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update recipe");
  }

  return response.json();
};
  
  // Fonction pour supprimer une recette
  export async function deleteRecipe(recipeId) {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found. Please log in.');
    }
  
    const response = await fetch(`${API_BASE_URL}/recipts/${recipeId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error(await response.text());
    }
  
    return response.json();
}

// Fonction pour récupérer une recette par ID
export async function getRecipe(recipeId) {
    const response = await fetch(`${API_BASE_URL}/recipts/${recipeId}`);
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
}

// Fonction pour liker une recette
export async function likeRecipe(recipeId) {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found. Please log in.');
    }

    const response = await fetch(`${API_BASE_URL}/recipts/${recipeId}/like`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error(await response.text());
    }

    return response.json();
}

// Fonction pour disliker une recette
export async function dislikeRecipe(recipeId) {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found. Please log in.');
    }

    const response = await fetch(`${API_BASE_URL}/recipts/${recipeId}/dislike`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error(await response.text());
    }

    return response.json();
}

// Add a recipe to favourites
export async function addFavourite(recipeId) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No token found. Please log in.');
  }

  const response = await fetch(`${API_BASE_URL}/recipts/${recipeId}/favourites`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

// Remove a recipe from favourites
export async function removeFavourite(recipeId) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No token found. Please log in.');
  }

  const response = await fetch(`${API_BASE_URL}/recipts/${recipeId}/favourites`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

// Get all favourite recipes
export async function getFavourites() {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No token found. Please log in.');
  }

  const response = await fetch(`${API_BASE_URL}/recipts/favourites`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}